import React from 'react';
import { Header, Footer } from '../Common';
import CollectionShop from '../../Common/CollectionShop/CollectionShop';

/** ABC-SE public collection-shop listing (/clothing/abc-se/collection/:collectionSlug). */
const ABCSECollectionShop = () => (
  <CollectionShop
    brandSlug="abcse"
    feSlug="abc-se"
    dataBrand="ABC"
    HeaderComponent={Header}
    FooterComponent={Footer}
    packageDescription="Paketlösning"
    loadingText="Laddar produkter…"
    emptyTitle="Inga produkter just nu"
    emptyText="Kollektionen kanske uppdateras just nu. Har du frågor hjälper vi gärna till."
    contactLabel="Kontakta oss"
    faqLabel="Se FAQ"
  />
);

export default ABCSECollectionShop;
